// import React from 'react';
// import { motion } from 'framer-motion';
// import { useNavigate } from 'react-router-dom';
// import { ArrowRight, MoveRight } from 'lucide-react';

// const AboutPreview = () => {
//   const navigate = useNavigate();

//   // Animation for the bee icon
//   const beeVariants = {
//     initial: { x: -20, y: 0, opacity: 0 },
//     hover: { 
//       x: [0, 10, 0, 10, 400], // "Z" shaped flight path
//       y: [0, -10, 10, -5, 0],
//       opacity: [1, 1, 1, 1, 0],
//       transition: { duration: 1.5, ease: "easeInOut" }
//     }
//   };

//   return (
//     <section className="py-20 bg-[#fefae0] overflow-hidden">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="bg-white rounded-[2rem] shadow-2xl overflow-hidden flex flex-col md:flex-row items-center border border-[#d3a863]/20">
          
//           {/* Text Content */}
//           <div className="p-10 md:p-16 md:w-1/2">
//             <motion.div 
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//             >
//               <h3 className="text-[#f57c00] font-bold tracking-widest text-sm mb-4 uppercase">Our Purpose</h3>
//               <h2 className="text-3xl md:text-5xl font-extrabold text-[#333] mb-6 leading-tight">
//                 More than just honey, <br /> 
//                 <span className="text-[#d3a863]">it's a movement.</span>
//               </h2>
//               <p className="text-gray-600 text-lg mb-8 leading-relaxed">
//                 We started in SIBM Pune with a simple realization: a tiny bee holds the key to global agricultural prosperity. Discover how we are empowering farmers and saving the ecosystem.
//               </p>

//               {/* The Interactive Button */}
//               <motion.button
//                 whileHover="hover"
//                 onClick={() => navigate('/about')}
//                 className="relative group flex items-center gap-4 bg-[#f57c00] text-white px-8 py-4 rounded-full font-bold text-lg shadow-xl overflow-hidden"
//               >
//                 <span>Discover Our Story</span>
                
//                 {/* Animated Bee Icon */}
//                 <motion.div variants={beeVariants} className="absolute left-4">
//                    🐝
//                 </motion.div>

//                 <ArrowRight className="group-hover:translate-x-2 transition-transform" />
//               </motion.button>
//             </motion.div>
//           </div>

//           {/* Visual Image Side */}
//           <div className="md:w-1/2 h-[400px] md:h-[600px] relative">
//             <img 
//               src="https://images.unsplash.com/photo-1587334274328-64186a80aeee?auto=format&fit=crop&q=80" 
//               alt="Sustainable Beekeeping" 
//               className="w-full h-full object-cover"
//             />
//             {/* Decorative Overlay */}
//             <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-transparent hidden md:block" />
            
//             {/* Floating Card */}
//             <motion.div 
//               animate={{ y: [0, -15, 0] }}
//               transition={{ repeat: Infinity, duration: 4 }}
//               className="absolute bottom-10 right-10 bg-white p-6 rounded-2xl shadow-2xl border-l-8 border-[#f57c00] hidden lg:block"
//             >
//               <p className="text-4xl font-bold text-[#333]">100%</p>
//               <p className="text-sm text-gray-500 font-medium">Sustainable & Pure</p>
//             </motion.div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutPreview;



import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const AboutPreview = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 md:py-16 bg-[#f7f3f0] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Main Rectangular Container */}
        <div className="relative group rounded-[2rem] bg-[#f57c00] h-auto md:h-[400px] flex flex-col md:flex-row items-stretch overflow-hidden shadow-2xl">
          
          {/* Left Side: Visual with Honeycomb Mask */}
          <div className="md:w-5/12 relative overflow-hidden h-0 md:h-full">
            <img 
              src="https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?auto=format&fit=crop&q=80" 
              alt="Honey" 
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            {/* Glassmorphism Overlay Label */}
            <div className="absolute top-6 left-6 backdrop-blur-md bg-black/50 border border-white/30 px-4 py-2 rounded-full flex items-center gap-2 text-white">
              <Sparkles size={16} />
              <span className="text-xs font-bold uppercase tracking-widest">Est. 2023</span>
            </div>
          </div>

          {/* Right Side: Content Area */}
          <div className="md:w-7/12 bg-white p-8 md:p-12 flex flex-col justify-center relative">
            {/* Subtle Honeycomb Pattern Background */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none" 
                 style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23f57c00' fill-opacity='0.4'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E")` }}>
            </div>

            <motion.div 
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="relative z-10"
            >
              <div className="flex items-center gap-2 text-[#d3a863] mb-3">
                <div className="h-[2px] w-8 bg-[#d3a863]"></div>
                <span className="text-xs font-black uppercase tracking-[0.2em]">Our Heritage</span>
              </div>

              <h2 className="text-3xl md:text-4xl font-black text-[#333] mb-4 leading-[1.1]">
                Empowering Farmers <br />
                <span className="text-[#f57c00]">One Hive at a Time.</span>
              </h2>

              <p className="text-gray-500 text-sm md:text-base mb-8 max-w-lg leading-relaxed">
                Born in the halls of SIBM Pune, we bridge the gap between rural agriculture and sustainable honey production.
              </p>

              {/* Innovative Bee Button */}
              <div className="relative inline-block">
                <motion.button
                  onClick={() => navigate('/about')}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="flex items-center gap-4 bg-[#d3a863] hover:bg-[#f57c00] text-white pl-8 pr-4 py-3 rounded-xl transition-colors duration-300 font-bold group/btn"
                >
                  Explore Our Story
                  <div className="bg-white/20 p-2 rounded-lg">
                    <ArrowRight size={20} className="group-hover/btn:translate-x-1 transition-transform" />
                  </div>
                </motion.button>

                {/* The "Orbiting" Bee - Floats near the button */}
                <motion.div
                  animate={{ 
                    x: [0, 15, 0, -15, 0],
                    y: [0, -10, 10, -10, 0],
                  }}
                  transition={{ repeat: Infinity, duration: 4, ease: "linear" }}
                  className="absolute -top-6 -right-6 text-2xl pointer-events-none drop-shadow-lg"
                >
                  🐝
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;